import { render, staticRenderFns } from "./LevyRow.vue?vue&type=template&id=6ce4cde0&scoped=true&lang=pug"
import script from "./LevyRow.vue?vue&type=script&lang=ts"
export * from "./LevyRow.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6ce4cde0",
  null
  ,true
)

export default component.exports